export function getMetaContent(name) {
  return document.querySelector(`meta[name="${name}"]`)?.content
}

export function csrfParam() {
  return getMetaContent("csrf-param") || ""
}

export function csrfToken() {
  return getMetaContent("csrf-token") || ""
}

export const escapeHTML = (() => {
  const element = document.createElement("div")
  return (string = "") => {
    element.textContent = string
    return element.innerHTML
  }
})()

export const stripHTML = (() => {
  const element = document.createElement("div")
  return (html = "") => {
    element.innerHTML = html
    return element.textContent
  }
})()

export function domReady(callback = noop) {
  return new Promise((resolve) => {
    const ready = () => {
      callback()
      resolve()
    }
    if (document.readyState == "loading") {
      addEventListener("DOMContentLoaded", ready, { once: true })
    } else {
      ready()
    }
  })
}

export function nextIntersect(element, options = {}) {
  return new Promise((resolve) => {
    new IntersectionObserver(([entry], observer) => {
      if (!entry.isIntersecting) return
      observer.unobserve(element)
      observer.disconnect()
      resolve()
    }, options).observe(element)
  })
}

export function createElement(tagName, properties = {}) {
  return Object.assign(document.createElement(tagName), properties)
}

export function toggleMultipleClasses(element, options, ...classes) {
  return classes.map((className) => element.classList.toggle(className, options))
}

export function dispatchInputEvent(element) {
  return element.dispatchEvent(new Event("input", { bubbles: true }))
}

function noop() {}
